<template>
    <modal v-model="visible"
           large persistent
           :show-close-button="!cropperView || cropperView === 'index'"
           :title="title ? title : $t('action.edit_image')">
        <div class="flex-grow-1">
            <lazy-image-cropper-form v-if="action" :ratio="ratio"
                                :action="action"
                                method="PUT"
                                @success="data => $emit('success', data)"
                                ref="imageCropper"
                                :avatar="avatar"
                                :name="name"
                                :with-thumbnail="withThumbnail"
                                :help-size="helpSize"
                                :help-ratio="helpRatio"
                                :thumbnail="thumbnail"
                                :src="src" :existing="existing"
                                v-model:view="cropperView"
                                v-model:loading="isLoading"
                                :buttons="false"
                                @saved="handleSave"/>

            <lazy-image-cropper v-else :ratio="ratio"
                           ref="imageCropper"
                           :avatar="avatar"
                           :thumbnail="thumbnail"
                           :src="src" :existing="existing"
                           :help-size="helpSize"
                           :help-ratio="helpRatio"
                           v-model:view="cropperView"
                           v-model:loading="isLoading"
                           :buttons="false"
                           @saved="handleSave"/>
        </div>

        <template v-if="cropperView && cropperView !== 'index'" #button>
            <btn @click.prevent="$refs.imageCropper.goBack()" :disabled="isLoading">
                <Icon :icon="icons.back"/>
                <span>{{ $t('action.back') }}</span>
            </btn>
            <btn color="success" @click="$refs.imageCropper.save()" :loading="isLoading" :disabled="isLoading">
                <Icon :icon="icons.check"/>
                <span>{{ $t('action.upload_image') }}</span>
            </btn>
        </template>
    </modal>
</template>

<script>
import Loadable from "../../mixins/Loadable";
	import {backIcon, checkIcon} from "../../config";

    export default {
        name: 'ImageCropperModal',

        mixins: [Loadable],

		emits: ['success', 'input', 'saved', 'update:modelValue'],

        props: {
            // Whether the modal is currently visible
			modelValue: {
                type: Boolean,
                required: false
            },

            // The initial path / string of the image to show
            thumbnail: {
                default: null
            },

            // Whether to store the cropped image within a '[prop]_thumbnail' prop on the data and submit the uncropped image as the original prop
            withThumbnail: {
                type: Boolean,
                default: false
            },

            // The initial path / string of the image to edit
            src: {
                default: null
            },

            // The ratio of the image
            ratio: {
                type: Number,
                default: 1
            },

            // The optimal size of the image to upload to show within a help text to the user
            helpSize: {
                type: String,
                default: null
            },

            // The ratio of the image to show as a help text
            helpRatio: {
                type: String,
                default: '1/1'
            },

            // The url where to send the request or a custom function to execute instead of the default request to the server
            action: {
                type: [String, Function],
                default: null
            },

            title: {
                type: String,
                default: null
            },

            name: {
                type: String,
                default: null
            },

            // States if the preview shall be displayed as an avatar
            avatar: {
                type: Boolean,
                default: false
            },

			// The urls of the existing images to select
			existing: {
				type: Array,
				default: () => {
					return []
				}
			},

        },

        data() {
            return {
                visible: this.modelValue,
                cropperView: null,

				icons: {
					check: checkIcon,
					back: backIcon,
				}
            }
        },

        watch: {
			modelValue(value) {
                this.visible = value;
            },
            visible(visible) {
                if (!visible) {
                    this.cropperView = 'index'; // Reset the view
                    this.isLoading = false;
                }
                this.$emit('update:modelValue', visible)
            }
        },

        methods: {
            handleSave(image, cropData, existing, originalPreview, croppedPreview) {
                this.cropperView = 'index'; // Reset the view
                this.$emit('saved', image, cropData, existing, originalPreview, croppedPreview)
            }
        }
    }
</script>